/**
 * 通用js
 */


// 截取字符串处理空字符串报错
export function sh_substr(str, start, length) {
    if (str == null || str.length == '') {
        return ''
    } else {
        return str.substr(start, length)
    }
}

// 时间格式化
export function myDateFormat(fmt, date) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

// 截取字符串处理空字符串报错
export function isTimedOut(tarDate, delay) {
    const _delay = delay || 0;
    let date = new Date(tarDate);
    let min = date.getMinutes();
    date.setMinutes(min + _delay);
    return date > new Date() ? false : true;
}

// 截取字符串处理空字符串报错
export function getLastTime(sTime, delay) {
    let date = new Date(sTime);
    let min = date.getMinutes();
    date.setMinutes(min + delay);
    return myDateFormat('YYYY-mm-dd HH:MM:SS', date)
}

// 计算时间间隔
export function GetDateDiff(startTime, endTime) {
    var sTime = new Date(startTime); //开始时间
    var eTime = new Date(endTime);  //结束时间
    var divNum = 1000;  //作为除数的数字
    return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(divNum));
}
